// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"215":"7951efd7","352":"d14bdc56","453":"e98c1baf","742":"0ef63304"}[chunkId] + ".chunk.js";
};